<template>
  <div class="editorial">
    <div class="editorial_nav">

      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span> <span class="span2">阜外说心脏</span>
        </div>
      </div>
      
      <div class="editorial_left">
        <div class="express_rtitle">
          <div class="waike">阜外说心脏</div>
          <div class="waixian"></div>

        </div>


        <div class="messageBottom">


          <div class="topAll">
              
              <div class="tupian">
              <img src="http://www.chinacirculation.org/UploadFile/SiteNotice/Images/6369845442999537948817699.jpg" alt="">
              </div>

               <div class="wenzi">
                 <h4>简介</h4>
                 <span>“阜外说心脏”由《中国循环杂志》杂志社策划、主创，采用网络直播、微视频等方式，向广大心血管疾病患者提供科学、规范、靠谱的心血管疾病自我管理知识。经国家心血管病中心推荐，卫健委宣传司评选，“阜外说心脏”系列节目入选国家卫生健康委品牌活动推荐名单。</span>
               </div>
               

          </div>

          <div class="showTotal">
               <h3>往期回顾</h3>
               <!-- <span>第{{this.kai}}-{{this.mo}}</span> -->
               <span>总条数{{this.total}}</span>
            </div>


            <div>
                 <div class="bottomAll" :class="item.zt?'add1':''"   @mouseover="addtop(1,item.contentId)"
            @mouseout="addtop(2,item.contentId)"    @click="jump(33,item.contentId)"   v-for="(item,index) in list">

            <span  :class="item.zt?'add2':''"></span> 
            <li>{{item.title}}</li>
            </div> 

            </div>
        

          
        </div>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>

      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      currentPage3: 1,//当前页数
      total: 0,//总条数
      limit:20,//每页显示
      kai:1,
      mo:1,
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
	  	video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],
      //详情
      list:[
        
      ],
    }
  },

  methods:{
      index(){
        this.GetHomePageBlockInfo(2403)
        this.total = this.list.length;
      },

      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        this.GetHomePageBlockInfo(2403)
        console.log(`当前页: ${val}`);
      },

      GetHomePageBlockInfo(ChannelId){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": 201607080003,
        "pChannelId": 0,
        "channelId": ChannelId,
        "jChannelID": 0,
        "dataSourceType": 1,
        "dataShowType": 1,
        "curr": that.currentPage3,
        "limit": that.limit,
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          that.total = res.totalcount;
          that.hide = true;
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
      

      jump(num,contentId){ //跳转详情
        this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId}});
      },

      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].contentId){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .messageBottom{
        width: 100%;
        // margin-top: 200px;
        // height: 210px;
        // border:1px solid #ccc;

        .topAll{
          width: 100%;
          height: 300px;
          margin-top: 20px;
          margin-bottom: 20px;

          .tupian{
            width: 20%;
            height: 100%;
            float: left;
            img{
            width: 100%;
            height: 100%;
            border:1px solid #ccc;
          }
          }
          
          .wenzi{
            width: 60%;
            float: left;
            height: 100%;
            margin-left: 30px;
            padding-top: 50px;
            line-height: 40px;
            span{
              padding-top: 30px;
            }
          }
        }

        .showTotal{
          border-top: 1px solid #E2E2E2;
          margin-top: 55px;
          padding-top: 50px;
          padding-left: 80px;
        }

        .bottomAll{
          width: 100%;
          span{
          width: 10px;
          height: 10px;
          background: #2A2D3E;
          // border-radius: 50%;
          
          margin-right: 6px;
          margin-left: 16px;
          float: left;
          margin-top: 6px;
        clip-path: polygon(50% 0,100% 50%,50% 100%,0 50%);
        transition:1s clip-path;
          }
        }
        li{
          list-style-type: none;
          line-height: 30px;
          text-indent: 10px;
        }
      }
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        margin-bottom: 20px;
        // margin-top: 150px;
        .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2A2D3E;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }

      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .topContent{
           border: 1px solid #ccc;
           margin: 0 auto;
           width: 50%;
           height: 300px;
        }

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/surgery.vue